import {hasStore, destroyStore} from 'client/framework';
import {destroyQuestionStore} from './V2/useQuestionStores';

/**
 * Takes a list of question sets, and destroys any question stores that
 * were created from any questions in those question sets.
 *
 * Returns the number of stores that were destroyed.
 *
 * @param {List<*>} questionSets
 * @returns {number}
 */
export function destroyQuestionStoresForQuestionSets(questionSets) {
  let destroyedCount = 0;
  questionSets.forEach((questionSet) => {
    questionSet.getQuestions().forEach((question) => {
      const storeName = question.getStoreName();
      if (hasStore(storeName)) {
        destroyedCount += 1;
        destroyStore(storeName);
      }
      // Also evict the V2 zustand store registry (the legacy destroy above only covers legacy
      // stores) so item-bank/ordering stores don't accumulate across practice views.
      destroyQuestionStore(storeName);
    });
  });
  return destroyedCount;
}
